import { render, staticRenderFns } from "./PercentageCircleChart.vue?vue&type=template&id=65c8d974&scoped=true"
import script from "./PercentageCircleChart.vue?vue&type=script&lang=js"
export * from "./PercentageCircleChart.vue?vue&type=script&lang=js"
import style0 from "./PercentageCircleChart.vue?vue&type=style&index=0&id=65c8d974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8d974",
  null
  
)

export default component.exports